import { createSlice } from "@reduxjs/toolkit";
import {
  deleteBusiness,
  getBusiness,
  undoDeleteBusiness,
} from "./business.api";

const businessSlice = createSlice({
  name: "business",
  initialState: {
    business: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
    updateLocalOrder: (state, action) => {
      state.surname.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBusiness.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getBusiness.fulfilled, (state, action) => {
      state.loading = false;
      state.business = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalData = action.payload.meta.total;
    });
    builder.addCase(getBusiness.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteBusiness.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteBusiness.fulfilled, (state, action) => {
      const deletedId = action.payload.data._id;

      if (state.business.data) {
        state.business.data = state.business.data.filter((business) => {
          return business._id !== deletedId;
        });
        state.loading = false;
      } else {
        console.error(
          "state.business.data is not an array:",
          state.business.data
        );
      }
      state.loading = false;
    });
    builder.addCase(deleteBusiness.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteBusiness.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteBusiness.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.business.data) {
        state.business.data = state.business.data.filter((business) => {
          return business._id !== undodeletedId;
        });
        state.loading = false;
      } else {
        console.error(
          "state.business.data is not an array:",
          state.business.data
        );
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteBusiness.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = businessSlice.actions;
export default businessSlice.reducer;
